import './admin-nav.scss';

export const AdminNav = ({ sections, activeSection, onChange }) => {
  return (
    <nav className="admin-nav">
      {sections.map((section) => (
        <div key={section.key} className="admin-nav__section">
          <div className="admin-nav__section-label">{section.label}</div>
          {section.items.map((item) => (
            <button
              key={item.key}
              type="button"
              className={`admin-nav__item ${activeSection === item.key ? 'admin-nav__item--active' : ''}`}
              onClick={() => onChange(item.key)}
            >
              {item.label}
            </button>
          ))}
        </div>
      ))}
    </nav>
  );
};
